import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";
import * as entities from "entities";
import * as _ from "lodash";
import entityBase from "entityBase";
import { product_under_contr_cov_view } from "original";
import { c_model_info, product_custom_warranty_coverage, warranty_coverage } from "organized";
import { product_contact } from "./product_contact";

export class productExtended extends entityBase {
  product_under_contr_cov_view: KnockoutObservableArray<product_under_contr_cov_view>;
  meter_readings: KnockoutObservableArray<entities.meter_readings>;
  tech_meter_readings: KnockoutObservableArray<entities.meter_readings>;
  warranty_coverage: KnockoutObservableArray<warranty_coverage>;
  request_unit: KnockoutObservableArray<entities.request_unit>;
  model: KnockoutObservableArray<entities.model>;
  product_id: KnockoutObservable<string>;
  model_id: KnockoutObservable<string>;
  part_id: KnockoutObservable<string>;
  serial_id: KnockoutObservable<string>;
  place_address: KnockoutObservable<entities.place_address>;
  hostname: KnockoutObservable<string>;
  asset_id: KnockoutObservable<string>;

  place_id_owned_by: KnockoutObservable<string>;
  user_def1: KnockoutObservable<string>;
  user_def16: KnockoutObservable<string>;
  mac_address: KnockoutObservable<string>;
  device_id: KnockoutObservable<string>;

  service_model: KnockoutObservable<string>;
  c_model_info: KnockoutObservable<c_model_info>;
  product_contact: KnockoutObservableArray<product_contact>;
  default_contact: KnockoutObservable<string>;
  contr_status: KnockoutObservable<string>;
  delivery_address: KnockoutObservable<string>;

  //#region IoT related fields
  ip_address: KnockoutObservable<string>;
  life_counter: KnockoutObservable<string>;
  life_counter_converted: KnockoutComputed<number>;
  ext_active: KnockoutObservable<string>;
  ext_active_color: KnockoutComputed<string>;
  ext_black_lvl: KnockoutObservable<number>;
  ext_black_remaining_days: KnockoutObservable<number>;
  ext_cyan_lvl: KnockoutObservable<number>;
  ext_cyan_remaining_days: KnockoutObservable<number>;
  ext_magenta_lvl: KnockoutObservable<number>;
  ext_magenta_remaining_days: KnockoutObservable<number>;
  ext_yellow_lvl: KnockoutObservable<number>;
  ext_yellow_remaining_days: KnockoutObservable<number>;
  ext_waste_toner_status: KnockoutObservable<string>;
  ext_last_connection_dt: KnockoutObservable<Date>;
  ext_last_connection_dttm: KnockoutObservable<any>;
  ext_latest_black_counter: KnockoutObservable<number>;
  ext_latest_color_counter: KnockoutObservable<number>;
  ext_latest_total_counter: KnockoutObservable<number>;
  ext_iot_monitoring_tool: KnockoutObservable<string>;
  ext_iot_monitoring_group: KnockoutObservable<string>;
  ext_iot_monitoring_url: KnockoutObservable<string>;
  ext_latest_lvl1_counter: KnockoutObservable<number>;
  ext_latest_lvl2_counter: KnockoutObservable<number>;
  ext_latest_lvl3_counter: KnockoutObservable<number>;

  //#endregion

  custom_warranties: KnockoutObservableArray<product_custom_warranty_coverage>;

  constructor(item: any) {
    super();
    this.product_id = ko.observable(item.product_id);
    this.model_id = ko.observable(item.model_id);
    this.part_id = ko.observable(item.part_id);
    this.serial_id = ko.observable(item.serial_id);
    this.asset_id = ko.observable(item.asset_id);
    this.place_id_owned_by = ko.observable(item.place_id_owned_by);
    this.user_def1 = ko.observable(item.user_def1);
    this.user_def16 = ko.observable(item.user_def16);
    this.service_model = ko.observable(item.service_model);
    this.model = <KnockoutObservableArray<entities.model>>entities.loadRelation(item, "model", "single");
    this.request_unit = <KnockoutObservableArray<entities.request_unit>>(
      entities.loadRelation(item, "request_unit", "array")
    );
    this.warranty_coverage = <KnockoutObservableArray<warranty_coverage>>(
      this.loadRelation(item, warranty_coverage, "warranty_coverage", "array")
    );
    this.meter_readings = <KnockoutObservableArray<entities.meter_readings>>(
      entities.loadRelation(item, "meter_readings", "array")
    );
    this.tech_meter_readings = ko.observableArray(
      _.map(item.c_tech_meter_readings, (o) => {
        return new entities.meter_readings(o);
      }),
    );
    this.product_under_contr_cov_view = <KnockoutObservableArray<product_under_contr_cov_view>>(
      this.loadRelation(item, product_under_contr_cov_view, "product_under_contr_cov_view", "array")
    );
    this.place_address = ko.observable();
    if (item.place_address) {
      this.place_address(new entities.place_address(item.place_address));
    } else if (item.place_address_id) {
      this.place_address(
        new entities.place_address({
          address: { full_address: item.full_address, name: item.name },
          address_id: item.place_address_id,
        }),
      );
    }
    this.hostname = ko.observable();
    this.ip_address = ko.observable();
    this.life_counter = ko.observable();
    if (item.c_product_iot_data_view) {
      this.hostname = ko.observable(item.c_product_iot_data_view.hostname);
      this.ip_address = ko.observable(item.c_product_iot_data_view.ip_address);
      this.life_counter = ko.observable(item.c_product_iot_data_view.life_counter);
      this.mac_address = ko.observable(item.c_product_iot_data_view.mac_address);
      this.device_id = ko.observable(item.c_product_iot_data_view.device_id);
      this.ext_iot_monitoring_url = ko.observable(item.c_product_iot_data_view.monitoring_url);
    } else if (item.iot_device) {
      if (item.iot_device.c_iot_device_ext) {
        this.hostname = ko.observable(item.iot_device.c_iot_device_ext.ext_hostname);
        this.ip_address = ko.observable(item.iot_device.c_iot_device_ext.ext_ip_address);
        this.life_counter = ko.observable(item.iot_device.c_iot_device_ext.ext_life_counter);
        this.mac_address = ko.observable(item.iot_device.c_iot_device_ext.ext_mac_address);
        this.device_id = ko.observable(
          item.iot_device.c_iot_device_ext.device_id ? item.iot_device.c_iot_device_ext.device_id : "",
        );
      }
    } else if (item.ext_hostname || item.ext_ip_address || item.ext_latest_total_counter || item.ext_mac_address) {
      this.hostname = ko.observable(item.ext_hostname ? item.ext_hostname : "");
      this.ip_address = ko.observable(item.ext_ip_address ? item.ext_ip_address : "");
      this.life_counter = ko.observable(item.ext_latest_total_counter ? item.ext_latest_total_counter : "");
      this.mac_address = ko.observable(item.ext_mac_address ? item.ext_mac_address : "");
    }

    this.c_model_info = <KnockoutObservable<c_model_info>>this.loadRelation(item, c_model_info, "c_model_info");
    this.product_contact = <KnockoutObservableArray<product_contact>>(
      this.loadRelation(item, product_contact, "product_contact", "array")
    );

    this.default_contact = ko.observable(item?.default_contact);
    this.contr_status = ko.observable(item?.contr_status);

    this.delivery_address = ko.observable(item?.delivery_address);

    //#region IoT related fields initialization
    this.ext_active = ko.observable(item?.iot_device?.ext_active);
    this.ext_black_lvl = ko.observable(item?.iot_device?.ext_black_lvl);
    this.ext_cyan_lvl = ko.observable(item?.iot_device?.ext_cyan_lvl);
    this.ext_magenta_lvl = ko.observable(item?.iot_device?.ext_magenta_lvl);
    this.ext_yellow_lvl = ko.observable(item?.iot_device?.ext_yellow_lvl);
    this.ext_waste_toner_status = ko.observable(item?.iot_device?.ext_waste_toner_status);
    this.ext_last_connection_dt = ko.observable(
      this.formatJSONDate(item?.iot_device?.ext_last_connection_dttm || item?.ext_last_connection_dttm),
    );

    this.ext_last_connection_dttm = CustomObservables.formattedDateTimeObservable(this.ext_last_connection_dt);
    this.ext_latest_black_counter = ko.observable(item?.iot_device?.ext_latest_black_counter);
    this.ext_latest_color_counter = ko.observable(item?.iot_device?.ext_latest_color_counter);
    this.ext_latest_total_counter = ko.observable(item?.iot_device?.ext_latest_total_counter);
    this.ext_iot_monitoring_tool = ko.observable(item?.iot_device?.ext_iot_monitoring_tool);
    this.ext_iot_monitoring_group = ko.observable(item?.iot_device?.ext_iot_monitoring_group);

    this.life_counter_converted = ko.computed(() => {
      const result = parseInt(this.life_counter());
      if (!isNaN(result) && result !== -1) {
        return result;
      }

      return null;
    });

    this.ext_black_remaining_days = ko.observable(Number(item?.iot_device?.ext_black_remaining_days ?? 0));
    this.ext_cyan_remaining_days = ko.observable(Number(item?.iot_device?.ext_cyan_remaining_days ?? 0));
    this.ext_magenta_remaining_days = ko.observable(Number(item?.iot_device?.ext_magenta_remaining_days ?? 0));
    this.ext_yellow_remaining_days = ko.observable(Number(item?.iot_device?.ext_yellow_remaining_days ?? 0));

    this.ext_latest_lvl1_counter = ko.observable(item?.iot_device?.ext_latest_lvl1_counter);
    this.ext_latest_lvl2_counter = ko.observable(item?.iot_device?.ext_latest_lvl2_counter);
    this.ext_latest_lvl3_counter = ko.observable(item?.iot_device?.ext_latest_lvl3_counter);

    this.ext_active_color = ko.computed(() => {
      if (this.ext_active() === "Y") {
        return "green";
      } else if (this.ext_active() === "N") {
        return "red";
      }
      return "gray";
    });
    //#endregion

    const productWaranties = <KnockoutObservableArray<product_custom_warranty_coverage>>(
      this.loadRelation(item, product_custom_warranty_coverage, "custom_warranties", "array")
    );

    // Sort warranties by order ascending
    productWaranties.sort((a, b) => (a.order() || 0) - (b.order() || 0));

    this.custom_warranties = productWaranties;
  }
}
